/**
 * BR 前端配置：
 * - BR_ENABLED：功能开关（菜单/路由/锁定等）
 * - BR_REMINDER_ENABLED：控制供应商端所有 BR 首页弹框（BrPromptHost）：
 *     提交提醒 / 审批通过 / 审批驳回 / 即将过期
 *     正式宣导前保持 false；开启宣导时改为 true
 * - 锁定开始日以后端 AccessGate 为准
 * - AccessGate 失败时一律锁（逻辑写死在 brLock.js，无单独开关）
 */

import { startOfLocalDay } from './brPure';

export const BR_ENABLED = true;

/**
 * 供应商 BR 弹框总开关（须同时 BR_ENABLED=true 才生效）。
 * false：不挂载 BrPromptHost，四类弹框全部不出现。
 */
export const BR_REMINDER_ENABLED = false;

const BR_UPLOAD = {
  allowedFileTypes: [
    'image/jpeg',
    'image/png',
    'image/bmp',
    'image/x-ms-bmp',
    'image/heic',
    'image/heif',
    'image/webp',
    'application/pdf',
  ],
  minFileSizeBytes: 55 * 1024,
  maxFileSizeBytes: 5 * 1024 * 1024,
};

/** file input accept：图片 + PDF（对齐 BusinessLicenseSystemPrompt） */
export const BR_UPLOAD_ACCEPT = [
  '.jpg', '.jpeg', '.png', '.bmp', '.heic', '.heif', '.webp', '.pdf',
  'image/jpeg', 'image/png', 'image/bmp', 'image/heic', 'image/heif', 'image/webp',
  'application/pdf',
].join(',');

export const BR_FEATURE_CONFIG = {
  allowedFileTypes: BR_UPLOAD.allowedFileTypes,
  minFileSizeBytes: BR_UPLOAD.minFileSizeBytes,
  maxFileSizeBytes: BR_UPLOAD.maxFileSizeBytes,
};

export function isBrFeatureEnabled() {
  return !!BR_ENABLED;
}

export function isBrReminderEnabled() {
  /** 总开关：所有 BrPromptHost 弹框（提醒/通过/驳回/临期） */
  return !!BR_ENABLED && !!BR_REMINDER_ENABLED;
}

function parseLockStartDate(raw) {
  const text = String(raw || '').trim();
  if (!text) {
    return null;
  }
  const match = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(text);
  if (!match) {
    return null;
  }
  const date = new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  return Number.isNaN(date.getTime()) ? null : date;
}

/**
 * 是否已到锁定开始日（含当天）。
 * lockStartRaw 必须来自 AccessGate；无日期时返回 false（不凭前端猜）。
 */
export function isBrSubmissionDeadlinePassed(now = new Date(), lockStartRaw = '') {
  const deadline = parseLockStartDate(lockStartRaw);
  if (!deadline) {
    return false;
  }
  return startOfLocalDay(now).getTime() >= startOfLocalDay(deadline).getTime();
}
